import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { GetItemLotMainStore } from "../services/ItemManagementService";
import ItemLotFilters from "./ItemLotFilters";
import ItemLotSearchResults from "./ItemLotSearchResults";

// Item/Lot top tab (Delphi IMD0046 → qryIMLot). Lot-grained master grid (IMLOT joined IMITEM) + the lot's
// detail sub-tabs.
function ItemLotTab(props) {
  const accessToken = props.oidc?.user?.access_token;
  const currentUser = props.oidc?.user;
  const dynamicFormSetting = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
  const [dataSource, setDataSource] = useState(null);

  const searchData = (formFields) => {
    setDataSource(GetItemLotMainStore(accessToken, formFields || {}));
  };

  // Load once on mount (empty filter = all lots).
  useEffect(() => {
    setDataSource(GetItemLotMainStore(accessToken, {}));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accessToken]);

  return (
    <div>
      <ItemLotFilters currentUser={currentUser} DYNAMICFORMSETTING={dynamicFormSetting} searchData={searchData} />
      <ItemLotSearchResults data={dataSource} accessToken={accessToken} />
    </div>
  );
}

function mapStateToProps(state) { return { oidc: state.oidc }; }
export default connect(mapStateToProps)(ItemLotTab);
